import { render, staticRenderFns } from "./SubjectLink.vue?vue&type=template&id=789bbcc3&"
import script from "./SubjectLink.vue?vue&type=script&lang=js&"
export * from "./SubjectLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports